import styled from 'styled-components';

export const BusinessInfoCardContainer = styled.div`
  -moz-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  display: block;
  height: 100%;
  padding: 30px;
  margin: 30px;
  text-align: center;
`;

export const BusinessName = styled.div`
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  padding: 10px;
`;

export const BusinessInfoCardTable = styled.div`
  display: inline-block;
  height: 100%;
  width: 100%;
  text-align: center;
  margin: 10px auto;
  table {
    margin: 0 auto;
    border-collapse: collapse;
    width: 100%;
    max-width: 700px;
  }
  td {
    border: solid 1px black;
    padding: 10px;
    width: auto;
  }
  td.head {
    width: auto;
  }
`;

export const BusinessInfoButton = styled.div`
  display: inline-block;  
  text-align: center;
  border: solid 1px var(--logo-gray);
  font-size: 14px;
  font-weight: bold;
  padding: 10px;
  margin-top: 10px;
  &:hover {
    background-color: var(--logo-gray);
    cursor: pointer;
  }
`;
